import { UserNotificationModel } from './userNotificationModel';

export class UserMedicineHistoryModel {
  public userMedicineHistoryId: number;
  public userMedicineId: number;
  public userId: number;
  public medicineId: number;
  public medicineName: string;
  public authorisationStatus: number;
  public startDate?: string;
  public endDate?: string;
  public singleDose: string;
  public frequencyOfIntake: string;
  public intakeConditions: string;
  public comments: string;
  public prescriptionName: string;
  public userNotifications: Array<UserNotificationModel>;
  public notificationsCount: number;
  public prescriptionDoctor: string;
  public prescriptionId: number;
}